import { render, staticRenderFns } from "./MessageContentCell.vue?vue&type=template&id=0519e23f&"
import script from "./MessageContentCell.vue?vue&type=script&lang=babel&"
export * from "./MessageContentCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports